export function distM(lat1, lng1, lat2, lng2) {
  if ([lat1, lng1, lat2, lng2].some((v) => typeof v !== 'number')) return null;
  const R = 6371000,
    toR = (x) => (x * Math.PI) / 180;
  const dLat = toR(lat2 - lat1),
    dLng = toR(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) ** 2 + Math.cos(toR(lat1)) * Math.cos(toR(lat2)) * Math.sin(dLng / 2) ** 2;
  return Math.round(R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
}

export const RAYON_CHANTIER = 200; // mètres : tolérance "sur le chantier"

export function distLisible(m) {
  return m == null ? '' : m < 1000 ? m + ' m' : (m / 1000).toFixed(m < 10000 ? 1 : 0) + ' km';
}
